/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Y_Padding_Range_ErrorInputs */



/**
* | output |
* | --- |
* | "Vertical padding must be between 0 and 50" |
*
* @param {Iframe_Remote_Y_Padding_Range_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_y_padding_range_error = /** @type {((inputs?: Iframe_Remote_Y_Padding_Range_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Y_Padding_Range_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le padding vertical doit etre entre 0 et 50")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der vertikale Abstand muss zwischen 0 und 50 liegen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La spaziatura verticale deve essere compresa tra 0 e 50")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вертикальный отступ должен быть в диапазоне от 0 до 50.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El relleno vertical debe estar entre 0 y 50")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("垂直边距必须介于 0 和 50 之间。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("垂直パディングは0から50の間でなければなりません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्टिकल पैडिंग 0 और 50 के बीच होनी चाहिए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O espaçamento vertical deve estar entre 0 e 50.")
	return /** @type {LocalizedString} */ ("Vertical padding must be between 0 and 50")
});